/* eslint react/prop-types: 0 */
/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
/* eslint-disable */
import cssContent from 'css-loader?{"url":false}!./../../helpers/popups/popups.css';
/* eslint-enable */
import * as routes from '@educabot/educablocks-cosmos';

class CanvasSVGComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: props.width,
      height: props.height,
      iframeWidth: props.iframeWidth || '90%',
      iframeHeight: props.iframeHeight || '90%',
      backgroundColor: props.backgroundColor,
      svgUrl: '',
    };
    this.canvasRef = React.createRef();
    this.imageRef = React.createRef();
  }

  componentDidMount() {
    this.updateSvgUrl();
  }

  componentWillReceiveProps(nextProps) {
    const { width, height, iframeWidth, iframeHeight, backgroundColor } = nextProps;
    this.setState({ width, height, iframeWidth, iframeHeight, backgroundColor });
  }

  componentDidUpdate(prevProps) {
    const { content, svgWidth, svgHeight, svgX, svgY, width, height } = this.props;
    if (
      prevProps.content !== content
      || prevProps.svgWidth !== svgWidth
      || prevProps.svgHeight !== svgHeight
      || prevProps.svgX !== svgX
      || prevProps.svgY !== svgY
      || prevProps.width !== width
      || prevProps.height !== height
    ) {
      this.updateSvgUrl();
    }
  }

  componentWillUnmount() {
    const { svgUrl } = this.state;
    if (svgUrl) {
      URL.revokeObjectURL(svgUrl);
    }
  }

  // Blob y no data: un iframe data: tiene origen opaco y el navegador bloquea ahí las imágenes
  // externas de los bloques (FieldImage); un blob: URL hereda el origen de esta página.
  updateSvgUrl() {
    const { content, svgWidth, svgHeight, svgX, svgY, width, height } = this.props;

    let svgContent = (content) ? content.replace(/href="images/g, `href="${routes.bloquesUri}/images`) : '';
    svgContent = (svgContent) ? svgContent.replace(/href="\/images/g, `href="${routes.bloquesUri}/images`) : '';
    svgContent = svgContent.replace(/fill-opacity="0.8"/g, 'fill-opacity="1"');

    let css = cssContent.toString().replace(/\/images\//g, `${routes.bloquesUri}/images/`);
    css = `<defs><style type="text/css" xmlns="http://www.w3.org/1999/xhtml"><![CDATA[${css}]]></style></defs>`;
    const svg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="${width}" height="${height}" viewBox="${svgX} ${svgY} ${svgWidth} ${svgHeight}">${css}${svgContent}</svg>`;

    const blob = new Blob([svg], { type: 'image/svg+xml' });
    const svgUrl = URL.createObjectURL(blob);
    this.setState((prevState) => {
      if (prevState.svgUrl) {
        URL.revokeObjectURL(prevState.svgUrl);
      }
      return { svgUrl };
    });
  }

  render() {
    const { iframeWidth, iframeHeight, backgroundColor, width, height, svgUrl } = this.state;
    const padding = 0;
    const styles = {
      backgroundColor,
      padding: `${padding}px`,
      border: 'none',
      margin: 'auto',
      marginTop: '2.5%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: iframeHeight,
      width: iframeWidth,
      cursor: 'pointer !important',
    };

    return (
      <div className="canvas-svg">
        <iframe
          title="BlocksCanvas"
          ref={this.imageRef}
          src={svgUrl}
          width={width}
          height={height}
          style={styles}
          alt=""
        />
      </div>
    );
  }
}

const CanvasSVG = React.memo(CanvasSVGComp);
export default CanvasSVG;
